import styled from '@emotion/styled';

export const StatsPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
`;

export const Chart = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 600px;
  width: 100%;
`;

export const Charts = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AccountStats = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 8px;
  width: 100%;
  height: 100%;
`;
export const PredictStats = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 8px;
  width: 100%;
  height: 100%;
`;

export const AccountStatItem = styled.div`
  display: flex;
`;

export const PredictStatItem = styled.div`
  display: flex;
`;

export const ChartTitle = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 10px;
`;
